<!--
Author: W3layouts
Author URL: http://w3layouts.com
License: Creative Commons Attribution 3.0 Unported
License URL: http://creativecommons.org/licenses/by/3.0/
-->
<body>
  <!-- home -->
  <div id="home">
    <!-- banner -->
    <div class="banner_w3lspvt">
      <div class="banner-top1">
        <div class="container">
          <div class="banner-text text-center">
            <h1>
              <a
                href="index.html"
                class="logo text-wh text-uppercase font-weight-light"
                style="color: black;">Dustin Walker</a
              >
            </h1>
            <p class="text-bl text-li mt-3">Moin Moin</p>
            <div class="social-icons mt-4">
              <ul class="list-unstyled">
                <li>
                  <a
                    href="https://www.linkedin.com/in/dustin-walker-pro/"
                    target="_blank"
                  >
                    <span class="fa fa-linkedin" />
                  </a>
                </li>
                <!-- <li>
									<a href="#">
										<span class="fa fa-twitter"></span>
									</a>
								</li> -->
                <li>
                  <a href="https://github.com/Dustin-dusTir" target="_blank">
                    <span class="fa fa-github" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/dustinwalker/"
                    target="_blank"
                  >
                    <span class="fa fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
            <a
              href="#about"
              class="btn button-style mt-5"
              style="background: rgba(0,0,0,0.4);">Read More</a
            >
            <div>
              <a
                class="btn button-style mt-5"
                style="margin-right: 1em; color: white; background: rgba(0,0,0,0.4);"
                target="_blank"
                href="https://veilmail.io/e/mWccjP">Contact Me</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //banner -->
  </div>
  <!-- //home -->

  <!-- header -->
  <header class="py-2">
    <div class="container d-flex">
      <h4 class="mt-2 let">My Profile</h4>
      <!-- menu -->
      <ul id="menu">
        <li>
          <input id="check02" type="checkbox" name="menu" />
          <label for="check02"
            ><span class="fa fa-bars" aria-hidden="true" /></label
          >
          <ul class="submenu">
            <li><a href="index.html" class="active">Home</a></li>
            <li><a href="#about">My Self</a></li>
            <li><a href="#what">What i do ?</a></li>
            <li><a href="#resume">My Resume</a></li>
            <li><a href="#projects">Projects</a></li>
            <!-- <li><a href="#blog">Blog</a></li>
            <li><a href="#hire">Hire Me</a></li> -->
          </ul>
        </li>
      </ul>
      <!-- //menu -->
    </div>
  </header>
  <!-- //header -->

  <!-- about -->
  <section class="about py-5 position-relative" id="about">
    <div class="container pt-lg-4 pb-4">
      <h3 class="tittle-2">About Myself</h3>
      <div class="row">
        <div class="col-lg-6 about-img text-center" style="padding-left: 50px;">
          <img
            class="img-fluid"
            src="./images/2022_black and white.jpg"
            alt=""
          />
        </div>
        <div class="col-lg-6 about-right">
          <h4 class="about-tit">Hi !<br />I'm Dustin Walker</h4>
          <p style="padding-top:2em">
            I am a Generative AI Applications Engineer | Building Applications
            powered by AI
          </p>
          <p>
            I enjoy creating things, that ease my, or the lives of others,
            creations that improve the World, even by a tiny bit. I like making
            things that have never been done before. I always strive to find out
            the truth
          </p>
          <p>I excel at finding easy solutions for complex problems.</p>
          <!-- <a href="#hire" class="btn button-style-2 mt-5">Hire Me</a> -->
        </div>
      </div>
    </div>
  </section>
  <!-- //about -->

  <!-- about bottom -->
  <div class="serives-w3pvts pb-5 pt-2">
    <div class="container pb-xl-5 pb-lg-3">
      <div class="row welcome-bottom text-center mx-auto">
        <div class="col-lg-3 col-sm-6 welcome-grid">
          <span class="fa fa-lightbulb-o" />
          <h4 class="mt-4 mb-3 text-bl">Innovative Ideas</h4>
        </div>
        <div class="col-lg-3 col-sm-6 welcome-grid mt-sm-0 mt-4">
          <span class="fa fa-bar-chart" />
          <h4 class="mt-4 mb-3 text-bl">Science</h4>
        </div>
        <div class="col-lg-3 col-sm-6 welcome-grid mt-lg-0 mt-4">
          <span class="fa fa-folder-open" />
          <h4 class="mt-4 mb-3 text-bl">Creation</h4>
        </div>
        <div class="col-lg-3 col-sm-6 welcome-grid mt-lg-0 mt-4">
          <span class="fa fa-desktop" />
          <h4 class="mt-4 mb-3 text-bl">Solution</h4>
        </div>
      </div>
    </div>
  </div>
  <!-- //about bottom -->

  <!-- stats section -->
  <div class="stats py-5">
    <div class="container py-xl-5 py-lg-3">
      <div class="row text-center py-sm-3">
        <div class="col-md-3 col-sm-6 w3layouts_stats_left">
          <p class="counter"># 1</p>
          <p class="para-text-w3ls text-li">in class</p>
        </div>
        <div class="col-md-3 col-sm-6 w3layouts_stats_left mt-sm-0 mt-4">
          <p class="counter">> 40</p>
          <p class="para-text-w3ls text-li">ML Models developed</p>
        </div>
        <div class="col-md-3 col-sm-6 w3layouts_stats_left mt-md-0 mt-4">
          <p class="counter">29</p>
          <p class="para-text-w3ls text-li">GitHub Repositories</p>
        </div>
        <div class="col-md-3 col-sm-6 w3layouts_stats_left mt-md-0 mt-4">
          <p class="counter">225 kg</p>
          <p class="para-text-w3ls text-li">Deadlift</p>
        </div>
      </div>
    </div>
  </div>
  <!-- //stats section -->

  <!-- what -->
  <div class="services text-center pt-5 pb-lg-5" id="what">
    <div class="container py-xl-5 py-lg-3">
      <h3 class="tittle text-center text-bl mb-sm-5 mb-4">What i do ?</h3>
      <div class="row ser-styles ser-styles-res">
        <div class="col-lg-4">
          <div class="abt-block">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg">
                  <span class="fa fa-mobile" />
                </div>
              </div>
            </div>
            <h3>Solve Problems</h3>
            <p>The easiest way possible</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="abt-block border-back2">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg back2">
                  <span class="fa fa-lightbulb-o" />
                </div>
              </div>
            </div>
            <h3>Build Prototypes</h3>
            <p>With my vast amount of Mechatronics prototyping skills</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="abt-block border-back3">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg back3">
                  <span class="fa fa-pie-chart" />
                </div>
              </div>
            </div>
            <h3>Analyse Data</h3>
            <p>And understand the connections</p>
          </div>
        </div>
      </div>
      <div class="row ser-styles">
        <div class="col-lg-4">
          <div class="abt-block border-back4">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg back4">
                  <span class="fa fa-ravelry" />
                </div>
              </div>
            </div>
            <h3>Create Software</h3>
            <p>
              create all kinds of apps and scripts with advanced programming
              principles and good enough style
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="abt-block border-back5">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg back5">
                  <span class="fa fa-question" />
                </div>
              </div>
            </div>
            <h3>Ask Questions</h3>
            <p>
              Because asking the right questions is more important, than finding
              the right answer
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="abt-block border-back6">
            <div class="dodecagon">
              <div class="dodecagon-in">
                <div class="dodecagon-bg back6">
                  <span class="fa fa-pied-piper-alt" />
                </div>
              </div>
            </div>
            <h3>Entrepreneurship</h3>
            <p>
              Validated Learnings through a lean, iterative and creative process
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- //what -->

  <!-- resume -->
  <div class="middile-inner-con position-relative" id="resume">
    <div class="container pt-lg-5">
      <h3 class="tittle-2">My Resume</h3>
      <div class="d-lg-flex">
        <div class="col-lg-4 left-grid-resu">
          <img src="./images/per2.jpg" alt="" class="img-fluid" />
        </div>
        <div class="col-xl-7 col-lg-8 tab-main offset-xl-1 py-lg-0 py-5">
          <input id="tab1" type="radio" name="tabs" class="w3pvt-sm" checked />
          <label for="tab1"
            ><span
              class="fa fa-graduation-cap"
              aria-hidden="true"
            />Education</label
          >
          <input id="tab2" type="radio" class="w3pvt-sm" name="tabs" />
          <label for="tab2"
            ><span
              class="fa fa-briefcase"
              aria-hidden="true"
            />Experience</label
          >
          <section id="content1" class="mb-3">
            <div class="inner-w3pvt-wrap">
              <h4>Master in Digital Business Engineer</h4>
              <h6>- 2020-2021</h6>
              <p>
                Reutlingen University -- 70% Computer Science 30% Business
                Skills <br />
                with a focus on innovative Technologies like Big Data, Machine Learning,
                AI, IOT <br />
                with Intra- and Entrepreneurship Skills<br />
                <b>Valedictorian</b> and <b>Student Representative</b> <br />
                <em
                  ><b>Thesis:</b> Reinforcement Learning for Industrial Robots</em
                > <br />
                <b>Leading my Team</b> in the 3 most demanding courses (AI, Project,
                Distributed Systems)
              </p>
            </div>
            <div class="inner-w3pvt-wrap mt-3">
              <h4>Bachelor in Mechatronics Engineering</h4>
              <h6>- 2017 to 2021</h6>
              <p>
                Reutlingen University -- Specialized in Automation, which was
                mostly Computer Science though.
              </p>
            </div>

            <div class="inner-w3pvt-wrap">
              <h4>Apprenticeship Mechatronics</h4>
              <h6>- Robert Bosch GmbH Reutlingen- 2018</h6>
              <p>Done in just two years instead of 3.5</p>
            </div>
          </section>
          <section id="content2" class="mb-3">
            <div class="inner-w3pvt-wrap mt-3">
              <h4>Voluntary Data Engineer at ICF München</h4>
              <h6>- 2023/06</h6>
              <p>
                Connect data from various sources like CMS and accounting
                software;
              </p>
            </div>
            <div class="inner-w3pvt-wrap mt-3">
              <h4>Dev-Ops Engineer</h4>
              <h6>- 2022/11 to 2024/02 at Canon Production Printing</h6>
              <p>
                <b>Lead</b> the project for automating deploys. <br />
                Consolidating all software components into an OS-Image <br />
                improve performance by 50% <br />
                Streamline the development Process, by getting parties to agree on
                common Solutions and remove legacy requirements.
              </p>
            </div>
            <div class="inner-w3pvt-wrap mt-3">
              <h4>
                Master Thesis -- Reinforcement Learning for Industrial Robots
              </h4>
              <h6>
                - 2022/04 to 2022/11 at iT Engineering Software Innovations
              </h6>
              <p>
                With the help of Reinforcement Learning, an Agent is to be
                trained to output the <nobr>G-Code</nobr>, that controls
                industrial Robots like a Kuka <nobr>6-Axis</nobr> robot
              </p>
            </div>
            <div class="inner-w3pvt-wrap mt-3">
              <h4>working Student as Data Engineer</h4>
              <h6>- 2020 to 2021 at BOSCH Power Tools Leinfelden</h6>
              <p>Web Development (CMS) -- I have created more than 500 pages</p>
              <p>Web Development with Python, Plotly, dash</p>
              <p>
                develop Algorithms in Python for calculating point clouds and 2D
                room scans
              </p>
            </div>
            <div class="inner-w3pvt-wrap mt-3">
              <h4>various Personal Projects</h4>
              <h6>- 2016-forever</h6>
              <p>Check out my GitHub for more info</p>
              <p>
                I have built an electrical Desk with off-the-shelf Parts
                (Pictures on Instagram)
              </p>
            </div>
            <div class="inner-w3pvt-wrap">
              <h4>Bachelorthesis</h4>
              <h6>- 2020-2021 at BOSCH Power Tools Leinfelden</h6>
              <p>
                Designing a High Frequency bidirectional Isolation Circuit for
                microcontroller debugging communication
              </p>
            </div>
            <div class="inner-w3pvt-wrap">
              <h4>Praxissemester</h4>
              <h6>- 2018-2020 at BOSCH Power Tools Leinfelden</h6>
              <p>
                Prototyping, designing, programming, testing. Improving Panorama
                stitching with Machine Learning
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <!-- //resume -->

  <!-- middle section -->
  <section class="w3ls-bnrbtm py-5 text-center">
    <div class="container py-xl-5">
      <div class="cont-w3pvt">
        <h3 class="w3pvt-web-title">
          If you like what you see, I would love to meet you in an Interview for
          an Engineering Role
        </h3>
        <!-- <h3 class="w3pvt-web-title">Invite me to the Job-Interview to learn more about me</h3> -->
        <!-- <a href="#hire" class="btn button-style mt-sm-5 mt-4">Hire Me</a> -->
      </div>
    </div>
  </section>
  <!-- //middle section -->

  <!-- gallery -->
  <div class="gallery py-5" id="projects">
    <div class="container py-xl-5 py-lg-3">
      <h3 class="tittle text-center text-bl mb-sm-5 mb-4">Recent Projects</h3>
      <div class="news-grids text-center">
        <div class="row no-gutters news-grids text-center">
          <div class="col-md-4 gal-img">
            <a href="#gal3"
              ><img
                src="./images/g3.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
            <a href="#gal2"
              ><img
                src="./images/Pointclouds.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
          </div>
          <div class="col-md-4 gal-img">
            <a href="#gal4"
              ><img
                src="./images/desk.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
            <a href="#gal1"
              ><img
                src="./images/g1.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
          </div>
          <div class="col-md-4 gal-img">
            <a href="#gal5"
              ><img
                src="./images/g5.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
            <a href="#gal6"
              ><img
                src="./images/g6.jpg"
                alt="news image"
                class="img-fluid"
              /></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- popup-->
  <div id="gal1" class="popup-effect animate">
    <div class="popup">
      <img src="./images/g1.jpg" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">
        Nulla viverra pharetra se, eget pulvinar neque pharetra ac int. placerat
        placerat dolor.
      </p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup -->
  <!-- popup-->
  <div id="gal2" class="popup-effect animate">
    <div class="popup">
      <img src="./images/Pointclouds.png" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">
        Vergleich-von-Messmethoden-fuer-Punktwolken (simulation with python)
      </p>
      <p class="mt-4">
        Check it out: <a
          href="https://www.kaggle.com/dustindustir/vergleich-von-messmethoden-fuer-punktwolken"
          target="blank">www.kaggle.com</a
        >
      </p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup -->
  <!-- popup-->
  <div id="gal3" class="popup-effect animate">
    <div class="popup">
      <img src="./images/g3.jpg" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">
        Nulla viverra pharetra se, eget pulvinar neque pharetra ac int. placerat
        placerat dolor.
      </p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup3 -->
  <!-- popup-->
  <div id="gal4" class="popup-effect animate">
    <div class="popup">
      <img src="./images/desk.jpg" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">DIY Electrical Desk with fancy LED Lamp</p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup -->
  <!-- popup-->
  <div id="gal5" class="popup-effect animate">
    <div class="popup">
      <img src="./images/g5.jpg" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">
        Nulla viverra pharetra se, eget pulvinar neque pharetra ac int. placerat
        placerat dolor.
      </p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup -->
  <!-- popup-->
  <div id="gal6" class="popup-effect animate">
    <div class="popup">
      <img src="./images/g6.jpg" alt="Popup Image" class="img-fluid" />
      <p class="mt-4">
        Nulla viverra pharetra se, eget pulvinar neque pharetra ac int. placerat
        placerat dolor.
      </p>
      <a class="close" href="#gallery">&times;</a>
    </div>
  </div>
  <!-- //popup -->
  <!-- //gallery -->

  <!-- testimonials -->
  <!-- <section class="testimonials py-5">
		<div class="container py-xl-5 py-lg-3">
			<div class="testimonials_grid d-flex">
				<div class="offset-lg-4 offset-md-3 testi_grid">
					<p class="sub-test">Integer sit amet mattis quam, sit amet ultricies velit. Nam libero tempore, cum soluta
						nobis est eligendi optio cumque nihil impedit quo minus id quod possimus, omnis voluptas.
					</p>
					<div class="d-flex">
						<span class="fa fa-user" aria-hidden="true"></span>
						<h5>Thomas Carl</h5>
					</div>
				</div>
			</div>
			<div class="testimonials_grid d-flex mt-4">
				<div class="offset-lg-4 offset-md-3 testi_grid">
					<p class="sub-test">Integer sit amet mattis quam, sit amet ultricies velit. Nam libero tempore, cum soluta
						nobis est eligendi optio cumque nihil impedit quo minus id quod possimus, omnis voluptas.
					</p>
					<div class="d-flex">
						<span class="fa fa-user" aria-hidden="true"></span>
						<h5>Anna Mull</h5>
					</div>
				</div>
			</div>
		</div>
	</section> -->
  <!-- //testimonials -->

  <!-- contact -->
  <!-- <section class="contact py-5" id="hire">
		<div class="container py-xl-5 py-lg-3">
			<h3 class="tittle text-center text-bl mb-sm-5 mb-4">Talk to me ! (Does not work!!!!)</h3>
			<div class="contact-form mx-auto text-center">
				<form method="post" action="#">
					<div class="row">
						<div class="col-lg-6 form-group">
							<input type="text" class="form-control" placeholder="Name" name="name" required="">
						</div>
						<div class="col-lg-6 form-group">
							<input type="email" class="form-control" placeholder="Email" name="email" required="">
						</div>
					</div>
					<div class="form-group">
						<input type="text" class="form-control" placeholder="Subject" name="subject" required="">
					</div>
					<div class="form-group">
						<textarea name="message" class="form-control" placeholder="Message" required=""></textarea>
					</div>
					<button type="submit" class="btn submit-button mt-md-4 mt-3">Submit</button>
				</form>
			</div>
		</div>
	</section> -->
  <!-- //contact -->

  <!-- footer -->
  <footer class="text-center py-5">
    <div class="container py-xl-5 py-lg-4">
      <div class="logo-2">
        <h2>
          <a
            href="index.html"
            class="logo text-wh text-uppercase font-weight-light"
            >this was DUSTINs <em>amazing</em> Website</a
          >
        </h2>
        <p class="foot-para mx-auto mt-3">
          This website has been Published with DEV OPS or Continous Deployment
          on netlify
        </p>
        <p>for free XD</p>
      </div>
      <div class="w3pvt-webinfo_social_icons mt-lg-5 mt-4">
        <h3 class="footer-title text-wh mb-lg-4 mb-3">Follow Me</h3>
        <ul class="w3pvt-webits_social_list list-unstyled">
          <li class="w3_w3pvt-web_dribble">
            <a href="#">
              <span class="fa fa-dribbble" />
            </a>
          </li>
          <li class="w3_w3pvt-web_facebook">
            <a href="https://github.com/Dustin-dusTir" target="_blank">
              <span class="fa fa-github" />
            </a>
          </li>
          <li class="w3_w3pvt-web_google">
            <a href="https://www.instagram.com/dustinwalker/" target="_blank">
              <span class="fa fa-instagram" />
            </a>
          </li>
        </ul>
      </div>
      <div class="cpy-right text-center mx-auto py-3">
        <p class="border-top mt-lg-5 mt-4">
          © 2019 Anent. All rights reserved | Design by
          <a href="http://w3layouts.com"> W3layouts.</a>
        </p>
      </div>
    </div>
  </footer>
  <!-- //footer -->
  <!-- move top icon -->
  <a href="#home" class="move-top text-center" />
  <!-- //move top icon -->
</body>
